import { render, staticRenderFns } from "./periodForm.vue?vue&type=template&id=d2afa180&"
import script from "./periodForm.vue?vue&type=script&lang=js&"
export * from "./periodForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2afa180')) {
      api.createRecord('d2afa180', component.options)
    } else {
      api.reload('d2afa180', component.options)
    }
    module.hot.accept("./periodForm.vue?vue&type=template&id=d2afa180&", function () {
      api.rerender('d2afa180', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/policy/entry/periodForm.vue"
export default component.exports